import { getPathWithRootPath } from '../../Services/common';
import { Badge } from '../../Types/badge';
import './BadgeDisplay.scss';

interface BadgeDisplayProps {
	badge: Badge;
	size?: 'small' | 'medium' | 'large';
}

const BadgeDisplay = ({ badge, size = 'medium' }: BadgeDisplayProps) => {
	const isEarned = badge.UserHasEarned;

	return (
		<div className={`biz-badge-display biz-badge-display--${size} ${!isEarned ? 'biz-badge-display--not-earned' : ''}`}>
			<div className='biz-badge-display__image-container'>
				{badge.ImageUrl ? (
					<img src={getPathWithRootPath(badge.ImageUrl)} alt={badge.Name} className='biz-badge-display__image' />
				) : (
					<div className='biz-badge-display__placeholder'>
						<span className='biz-badge-display__placeholder-icon' aria-label='Trophy icon'>
							🏆
						</span>
					</div>
				)}
				{!isEarned && <div className='biz-badge-display__overlay'></div>}
			</div>
			<div className='biz-badge-display__content'>
				<h4 className='biz-badge-display__name'>{badge.Name}</h4>
				{badge.Description && <p className='biz-badge-display__description'>{badge.Description}</p>}
				{isEarned && badge.UserAwardedDate && (
					<p className='biz-badge-display__earned-date'>
						Earned: {new Date(badge.UserAwardedDate).toLocaleDateString()}
					</p>
				)}
			</div>
		</div>
	);
};

export default BadgeDisplay;
